// extracted by mini-css-extract-plugin
export var readonly = "_gn-1";
export var star = "_gn-0";